import React from 'react'

import BaseHeader from 'components/landing/SmallHeader'
import { formatPrice } from 'components/utils/pricing'

type HeaderProps = {
  referral: GQL_GetCustomerReferralQuery['customerReferral']
}

const Header = ({ referral }: HeaderProps) => (
  <BaseHeader
    h1Text={`It's time to live fully, ${referral.recipientFirstName}.`}
    h2Text={`${
      referral.referrer.firstName
    } wants to share the gift of adventure with you, with a ${formatPrice(
      referral.referralVoucher.amount
    )} voucher to put towards your first Riparide escape.`}
    h3Text={formatPrice(referral.referralVoucher.amount)}
    imageUrl="https://assets.riparide.com/landing_pages/referrals/header/hero.jpg"
  />
)

export default Header
